// @ts-nocheck
export interface BlobFile {
    filename: string;
    blob: Blob;
}

const downloadBlobFile = ({ filename, blob }: BlobFile) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    link.remove();
};

export default downloadBlobFile;
